import { render, staticRenderFns } from "./AddZoneGroup.vue?vue&type=template&id=3ddc6fb2"
import script from "./AddZoneGroup.vue?vue&type=script&lang=js"
export * from "./AddZoneGroup.vue?vue&type=script&lang=js"
import style0 from "./AddZoneGroup.vue?vue&type=style&index=0&id=3ddc6fb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports